export const EMAIL_REGEX = /^(?=^.{1,51}$)(?=[a-zA-Z0-9])(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX = /^(?=.*[a-zA-Zа-яА-Я])(?=.*[0-9])(?=.*[~`!@#$%^&*()_\-+={[}\]|:;"'<,>.?/]).*$/;
export const ONE_UPPERCASE_ONE_LOWERCASE = /^(?=.*[a-zа-я])(?=.*[A-ZА-Я]).{2,}$/;
export const SYMBOLS = /[~`!@#$%^&*()_\-+={[}\]|:;"'<,>.?/]+/;
export const FACILITY_NAME_REGEX = /^(?=.*[a-zA-Zа-яА-Я0-9 ])[a-zA-Zа-яА-Я0-9 ]{1,}$/;
export const ALPHANUMERIC_ONE_OR_MORE = /^[a-zA-Zа-яА-Я0-9 ]+$/;
export const ALPHANUMERIC_ONE_OR_MORE_NO_SPACE = /^[a-zA-Zа-яА-Я0-9]+$/;
export const FIRMWARE_NAME_REGEX = /^(?!.*[А-Яа-я])[\W\S\s]+$/;
export const SN_REGEX = /^[a-zA-Z0-9-+/]+$/;
export const INDEX_REGEX = /^\s*?[a-zA-Zа-яА-Я0-9.,:-]+\s*?$/;
export const NO_SPACES_REGEX = /^\S+$/;
export const POWER_CONTROL_NAME_REGEX = /^[.,\-_ a-zA-Zа-яА-Я0-9]{1,}$/;
